import ReactApexChart from "react-apexcharts";

export const PieChart = ({
  data = [],
  colors = ["#FBD8B0", "#74DFD5"],
  showLegend = true,
  height = 400,
  width = 400
}) => {
  // Defensive: ensure data is always an array
  const safeData = Array.isArray(data) ? data : [];
  const labels = safeData.map(d => d.name);
  const series = safeData.map(d => d.value);

  return (
    <ReactApexChart
      options={{
        colors: colors,
        chart: {
          type: "pie"
        },
        labels: labels,
        legend: {
          show: showLegend,
          position: "left"
        },
        yaxis: {
          labels: {
            formatter: value => value.toFixed(0)
          }
        },
        noData: {
          text: "No data available",
          align: "center",
          verticalAlign: "middle"
        }
      }}
      series={series}
      type="pie"
      height={height}
      width={width}
    />
  );
};
